'use client';

import { useEffect } from 'react';
import { useLanguage } from '@/hooks/use-language';

export function HtmlLangUpdater() {
  const { lang, dir } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    document.body.style.direction = dir;
  }, [lang, dir]);

  return null;
}
